import { ReactNode } from 'react';
import { Label } from '../Label/Label';
import styles from '../_pages/StepConfirmData/StepConfirmData.module.scss';
import { getDataTest } from '../../utils/dataTests';

type Props = {
    label: string;
    children: ReactNode;
};

export const DataPlaceholder = ({ label, children, ...props }: Props) => (
    <div {...props}>
        <Label data-test={getDataTest(props, 'Label')}>{label}</Label>
        <div className={styles.boxValue} data-test={getDataTest(props, 'Content')}>
            {children}
        </div>
    </div>
);
